export default "__VITE_ASSET__2f40822a__"